(function () {
  'use strict';

  angular.module('app').component('packageContentDayList', packageContentDayList());

  function packageContentDayList() {
    return {
      bindings: {
        items: '=',
        packageContent: '=',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: PackageContentDayListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/package-contents/package-content-days/' +
        'package-content-day-list/package-content-day-list.component.html',
    };
  }

  PackageContentDayListComponent.$inject = ['UtilService', 'PackageContentDayService'];

  function PackageContentDayListComponent(UtilService, PackageContentDayService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.showPackageContentDayDetail = showPackageContentDayDetail;

    vm.$onInit = function () {
      vm.items = vm.UtilService.cleanItemsCache(vm.items, 'logo');
    };

    function showPackageContentDayDetail(day, mode) {
      var successCallback = function () {}; // createMode

      PackageContentDayService.openPackageContentDayDetailModal(
        day,
        mode,
        vm.packageContent,
        vm.defaultLanguage,
        vm.additionalLanguages,
        successCallback
      );
    }
  }
})();
